import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Formik, FormikValues } from 'formik';
import * as Yup from 'yup';

import createCity from '../../../lib/apiClient/cities/create';
import { selectMunicipalities } from '../../../redux/reducers/MunicipalitiesReducer';

import FormikInputField from '../../common/ui/FormikInputField/Input';
import PopupForm from '../../common/ui/PopupForm/Form';
import PopupFormHeader from '../../common/ui/PopupForm/Header';
import PopupFormErrorMessage from '../../common/ui/PopupForm/ErrorMessage';
import Search from '../../common/ui/Search/Search';
import Button from '../../common/ui/Button/Button';

interface Props {
  onClose(): void;
}

const CreateCityPopup = ({ onClose }: Props) => {
  const [error, setError] = useState<string | null>(null);

  const municipalities = Object.values(useSelector(selectMunicipalities));
  const municipalitiesNames = municipalities.map(({ name }) => name);

  const initialValues = { name: '', municipality: '' };

  const validationSchema = Yup.object({
    name: Yup.string()
      .max(255, 'Максимальная длина - 255 символов')
      .required('Обязательное поле'),
    municipality: Yup.string()
      .oneOf(municipalitiesNames, 'Указанного муниципалитета не существует')
      .required('Обязательное поле'),
  });

  const submit = async ({ name, municipality }: FormikValues) => {
    try {
      const municipalityId = municipalities.find(
        ({ name: municipalityName }) => municipalityName === municipality,
      )?.id!;

      await createCity({ name, municipalityId });
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={submit}
    >
      <PopupForm close={onClose} closable>
        <PopupFormHeader>
          Добавление города
          <PopupFormErrorMessage text={error ?? ''} visible={error !== null} />
        </PopupFormHeader>

        <FormikInputField
          name="name"
          placeholder="Название"
          onFocus={() => setError(null)}
        />

        <Search
          name="municipality"
          placeholder="Муниципалитет"
          options={municipalitiesNames}
          onFocus={() => setError(null)}
        />

        <Button type="submit">Подтвердить</Button>
      </PopupForm>
    </Formik>
  );
};

export default CreateCityPopup;
